import * as React from "react"
import {Box, Flex, LinkBox, LinkOverlay} from '@chakra-ui/react'
import Spotify from './images/spotify.svg'
import Separator from "../separator/separator";
import ThumbWithCat from "./thumbWithCat";
import Author from "../author/author";
import {StaticImage} from "gatsby-plugin-image";

export default function PostBox(props) {

    const post = props.node
    const hideimg = (props.hideimg) ? props.hideimg : undefined
    const noicons = (props.noicons) ? props.noicons : undefined
    const variant = props?.variant ? props.variant : undefined

    const lang = post?.language?.code ?? 'PL'


    const postSocials = post.knowledgeBaseACF ? post.knowledgeBaseACF : post.newsACF ? post.newsACF : post.postACF
    const readingTime = post?.readingTime?.time ?? '0'

    return (
        <LinkBox paddingBottom = {{base:'30px', lg: '0'}} borderBottom={{ base: '1px solid', lg: '0'}} borderColor={'gray.light'} display={'flex'} flexDirection={'column'} height={'100%'}
            sx={{
                '.featuredImage .gatsby-image-wrapper' : { transition : 'all 0.25s ease-out', backgroundColor:'#f8f8f8'},
                '.featuredImage .gatsby-image-wrapper picture' : { mixBlendMode : 'multiply'},
                '.featuredImage .gatsby-image-wrapper:before' : { transition : 'all 0.25s ease-out' },
                '&:hover .featuredImage .gatsby-image-wrapper' : { transform : 'scale(1.085)' },
                '&:hover .postTitle' : {color: '#828282'},
                // '&:hover .gatsby-image-wrapper:before' : { transform : 'scale(.925)' },
            }}
        >
            <ThumbWithCat {...props} />
            <Box mt={'20px'} display={'flex'} flexDirection={'column'} flexGrow={'1'}>
                <Flex color={'gray.darker'} fontSize={'13px'} lineHeight={'17px'} justifyContent={'space-between'} alignItems={'center'} mb={'10px'}
                >
                    <Flex>{lang === 'EN' ? post.dateEN : post.datePL} <Separator h={'17px'} m={'0 10px'}/> <Box as={'span'}>{readingTime} min.</Box></Flex>
                    {(noicons === undefined && postSocials) &&
                        <Flex className={'socials'}>
                            {postSocials.spotify && <StaticImage src={'./images/spotify.png'} alt={'Spotify'} style={{marginRight: '10px',width: '24px',height:'24px'}}/>}
                            {postSocials.youtube && <StaticImage src={'./images/yt.png'} alt={'Youtube'} style={{width: '24px',height:'24px'}}/>}
                        </Flex>
                    }
                </Flex>
                <LinkOverlay href={post.uri} title={post.title.replace(/[\u200B-\u200D\uFEFF]/g, '')} mb={'20px'}><Box as={'span'} className={'postTitle'} transition={'color .25s ease'} fontWeight={'bold'} fontSize={{base:'17px', mobile:'14px', md:'18px', lg:variant && variant === 'small' ? '14px' : '18px', laptop:variant && variant === 'small' ? '15px' : '18px', xxl:'18px'}} dangerouslySetInnerHTML={{__html:post.title}}/></LinkOverlay>
                <Author author = {post.author} mt={'auto'} mb={'0'} hideimg={hideimg} lang={lang}/>
            </Box>
        </LinkBox>
    )
}